export class UserLogin {
    userName: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/app/models/userLogin.ts